import { http } from '@/utils/request'

export interface caseQueryParams {
    caseName: string, //案例名称
    category: number, //类别
    industry: number, //行业
}

// 案例相关 API
export const odCaseApi = {
    // 获取案例
    getOdCases: (params: caseQueryParams) =>
        http.get('/case/list', params),

}